const productTypeLabels = {
  month: "月度证书", year: "年度证书", quota_recharge: "次数充值", duration_recharge: "有效期充值",
};

function updateNavigationForSession() {
  fetch("/api/auth/me", { credentials: "same-origin", headers: { Accept: "application/json" } })
    .then((response) => {
      if (!response.ok) return;
      document.querySelectorAll('[data-auth="guest"]').forEach((element) => element.classList.add("d-none"));
      document.querySelectorAll('[data-auth="user"]').forEach((element) => element.classList.remove("d-none"));
    })
    .catch(() => {});
}

updateNavigationForSession();

function formatPrice(priceCents) {
  return new Intl.NumberFormat("zh-CN", { style: "currency", currency: "CNY", minimumFractionDigits: 2 }).format(priceCents / 100);
}

function escapeHtml(value) {
  return String(value).replace(/[&<>"']/g, (character) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;" })[character]);
}

function productDetail(product) {
  const details = [];
  if (product.quotaAmount > 0) details.push(`${product.quotaAmount.toLocaleString("zh-CN")} 次转换额度`);
  if (product.durationMonths > 0) details.push(`${product.durationMonths} 个月有效期`);
  return details.join(" · ") || "具体权益以控制台为准";
}

function renderProducts(items) {
  const root = document.querySelector("#product-list");
  if (!root) return;
  if (!items.length) {
    root.innerHTML = '<div class="pricing-state">当前暂无在售商品。您仍可进入控制台查看账户与证书状态。<a href="/console/products">进入控制台</a></div>';
    return;
  }
  root.innerHTML = items.map((product) => `<article class="price-card">
    <span class="price-type">${productTypeLabels[product.type] || "产品"}</span>
    <h3>${escapeHtml(product.name)}</h3><p>${escapeHtml(product.description || "天工图学 API 服务产品")}</p>
    <strong class="price-value">${formatPrice(product.priceCents)}</strong>
    <small>${productDetail(product)}</small>
    <a class="btn btn-primary w-100" href="/console/products">进入控制台购买</a>
  </article>`).join("");
}

const productsRoot = document.querySelector("#product-list");
if (productsRoot) {
  fetch("/api/public/products", { headers: { Accept: "application/json" } })
    .then((response) => { if (!response.ok) throw new Error("request failed"); return response.json(); })
    .then((data) => renderProducts(Array.isArray(data.items) ? data.items : []))
    .catch(() => { productsRoot.innerHTML = '<div class="pricing-state pricing-error">商品信息暂时无法加载，请稍后重试或进入控制台查看。<a href="/console/products">进入控制台</a></div>'; });
}
